// extracted by mini-css-extract-plugin
export default {"Nav":"Tabs_Nav__BX66r"};